import { onBeforeMount } from 'vue'

let addressLookupPromise

export function useAddressLookup(config) {
  onBeforeMount(() => {
    if (config.environment === 'local' || window.location.href.includes('autotest')) return
    if (addressLookupPromise) return

    addressLookupPromise = new Promise((resolve, reject) => {
      if (window.data8) {
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = '/scripts/predictiveaddress.js'
      script.async = true
      script.onload = () => {
        resolve()
      }
      script.onerror = reject
      document.head.appendChild(script)

      const css = document.createElement('link')
      css.rel = 'stylesheet'
      css.href = 'https://webservices.data-8.co.uk/content/predictiveaddress.css'
      document.head.appendChild(css)
    })
  })

  const setupAddressLookup = async (id, callback) => {
    if (config.environment === 'local' || window.location.href.includes('autotest')) return
    await addressLookupPromise

    const txt = document.getElementById(id)
    new window.data8.predictiveaddressui(txt, {
      ajaxKey: 'MSS8-FTK3-3VI8-VF8T',
      placeholder: 'Please enter your address...',
      minDelay: 1000,
      fields: [
        { element: 'address1', field: 'line1' },
        { element: 'address2', field: 'line2' },
        { element: 'address3', field: 'line3' },
        { element: 'town', field: 'town' },
        { element: 'county', field: 'county' },
        { element: 'country', field: 'country' },
        { element: 'postcode', field: 'postcode' }
      ],
      selectAddress(address) {
        callback(address)
      }
    })
  }

  return {
    setupAddressLookup
  }
}
